import { useProductConfig } from '../utils/FetchConfig';
import { Shimmer, ShimmerElementType } from '@fluentui/react/lib/Shimmer';
import { IDropdownProps } from '../@types/dropdown';
import * as input from './connectedForm/inputComponents';
import { FilterOperation } from '../graphql/schema/p4types';
import React from 'react';
import Field from './connectedForm/Field';

const ConnectedPricingAttributeField = ({
  attributeIndex,
  dataid = `pricingAttributes.pricingAttribute${attributeIndex}`,
}: {
  attributeIndex: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10;
  dataid?: string;
}) => {
  const productConfig = useProductConfig();

  if (!productConfig) {
    const diff = (attributeIndex * 15) % 40;
    return (
      <Shimmer
        shimmerElements={[
          { type: ShimmerElementType.line, height: 14, width: 60 + diff },
          { type: ShimmerElementType.gap, width: 100 - diff },
          { type: ShimmerElementType.line, height: 14, width: '100%' },
          { type: ShimmerElementType.gap, width: 10 },
        ]}
        style={{ paddingTop: '7px', paddingBottom: '7px' }}
        shimmerColors={{
          shimmerWave: '#858585',
        }}
      />
    );
  }

  const title = productConfig[`pricingAttributeTitle${attributeIndex}`];

  if (!title) return null;

  return (
    <Field<IDropdownProps>
      dataid={dataid}
      component={input.Dropdown}
      label={title}
      temporary={true}
      initialized={true}
      rawLabel={true}
      predefinedFilters={[
        {
          filterOperation: FilterOperation.Equals,
          filterParameters: {
            field: 'pricingAttributeIndex',
            value: `${attributeIndex}`,
          },
        },
      ]}
    />
  );
};

export default ConnectedPricingAttributeField;
